module.exports = evite.exports.React;